import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from "react-router-dom";
import { connect } from "react-redux";
import { useQuery } from "@apollo/client";
import { bindActionCreators } from "redux";
import { addDownload, addPlaylistToDownloadQueue } from "../../../actions/downloadManager";
import { hideModalBokecc, hideSearchBar, setTitleBar, showBackArrow, showModalBokecc } from "../../../actions/ui";
import isElectron from "is-electron";
import { Black, Shadow, WerfenColor, White } from "../../Constants/ColorChart";
import { formatDateAsDay, processAsResource } from "../../../../web/Utils/utils";
import Loader from "../Loader/Loader";
import Header from "../Header/Header";
import IconWrapper from "../Icons/IconWrapper";
import SettingsIcon from "../Icons/Settings/Settings"
import DropdownMenu from "../Dropdown/DropdownMenu";
import { PlaylistByTabs } from "./PlaylistByTabs";
import { PlaylistAsTable } from "./PlaylistAsTable";

import { Form, Modal } from "react-bootstrap";
import Dialog from "../Dialog/Dialog";
import { PLAYLIST_QUERY } from "./Queries/PlaylistQuery";
import {
    Label,
    RelativeDiv,
    StyledDiv, StyledModalBody,
    TabSection,
    TabWrapper,
    StyledToggle,
    ToggleWrapper
} from "./PlaylistComponents/PlaylistComponents";

let electron;
if ( isElectron () ) {
    electron = window.require ( "electron" );
}
const ipcRenderer = electron && electron.ipcRenderer;

/*
 *  @Description:   Functional component that renders a playlist.
 */

const Playlist = ( props ) => {
    let history = useHistory ();
    let id = useParams ().id;
    let playlist;
    let combinedTabs;
    const { session } = props;
    const { settings } = props;


    const [ selectedTab, setSelectedTab ] = useState( null );
    const [ downloadedIds, setDownloadedIds ] = useState( [] );
    const [ has404, setHas404] = useState([])
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredTabs, setFilteredTabs] = useState(null);
    const [filteredCombinedTabs, setFilteredCombinedTabs] = useState([]);
    const [isUnifiedTable, setUnifiedTable] = useState(false)

    const createMarkup = ( html ) => {
        return { __html: html }
    }

    useEffect ( () => {
        props.hideSearchBar ();
        props.setTitleBar ( "Playlist" );
        props.showBackArrow ();

        if ( !id ) {
            history.push ( "/" )
        }

        if ( isElectron () ) {
            ipcRenderer.on ( "deletionFinished", getDownloadedIds );
            ipcRenderer.on ( "indexationFinished", getDownloadedIds );
            ipcRenderer.on ( "finishedGetDownloadedIds", storeDownloadedIds );

            ipcRenderer.send ( "getDownloadedItems", "ids" );
        }

        return () => {
            if ( isElectron () ) {
                ipcRenderer.off ( "deletionFinished", getDownloadedIds );
                ipcRenderer.off ( "indexationFinished", getDownloadedIds );
                ipcRenderer.off ( "finishedGetDownloadedIds", storeDownloadedIds );
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [] );

    useEffect ( () => {
        if ( isElectron () && playlist ) {
            getDownloadedIds ();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ props.download.length ] );

    const getDownloadedIds = () => {
        ipcRenderer.send ( "getDownloadedItems", "ids" );
    }

    const handleToggle = () => {
        setUnifiedTable ( !isUnifiedTable );
    };

    const storeDownloadedIds = ( event, downloadedItems ) => {
        setDownloadedIds ( downloadedItems.map ( item => item.id ) )
        setHas404 ( downloadedItems.filter ( item => item.is404 === true ).map ( item => item.id ) )
    }

    const convertTableDataIntoContextMenuData = ( tabs ) => {
        let tabContextActions = [];

        tabContextActions
            .push ( {
                name: "Todos",
                action: () => setSelectedTab ( null )
            } );

        tabs.map ( ( tab ) => (
            tabContextActions
                .push ( {
                    name: tab.title,
                    action: () => setSelectedTab ( tab )
                } )
        ) )
        return tabContextActions
    }

    const mapDataFromPlaylist = ( playlist ) => {
        if ( playlist && playlist.fieldPlaylistTabs ) {
            return playlist.fieldPlaylistTabs
                .filter( ( retrievedTab ) => retrievedTab !== null)
                .map ( ( retrievedTab ) => {
                    return {
                        title: retrievedTab.entity.title,
                        files: retrievedTab.entity.fieldTabItems
                            .filter ( item => ( item && item.entity && item.entity.fieldResourceFilesByFormat.length > 0 ) )
                            // eslint-disable-next-line array-callback-return
                            .map ( ( fieldTabItem ) => {
                                let resource = processAsResource ( fieldTabItem.entity );

                                if ( isElectron () ) {
                                    resource.isDownloading = props.download
                                        .map(item => item.resourceId)
                                        .includes(resource.id);

                                    resource.actions.isDownloaded = downloadedIds
                                        .includes ( resource.id );

                                    resource.is404 = has404
                                        .includes ( resource.id );
                                }

                                if ( resource ) {
                                    return resource
                                }

                            } )
                    };
                } )
        }
    }

    const classifyResult = ( playlist ) => {
        if ( playlist ) {
            const tabs = mapDataFromPlaylist ( playlist );
            const elementCounter = playlist && playlist.fieldPlaylistItemsCount;
            const availableOffline = downloadedIds.includes ( playlist.nid.toString () );
            const tabContextActions = convertTableDataIntoContextMenuData ( tabs );

            return {
                tabs,
                elementCounter,
                availableOffline,
                tabContextActions,
                entityType: playlist.entityType,
                modificationDate: playlist.entityChanged,
                id: playlist.nid,
                title: playlist.title,
                fieldPlaylistDescription: playlist.fieldPlaylistDescription,
                isFav: playlist.isLikedByCurrentUser,
            };
        }
    }

    const { loading, error, data } = useQuery ( PLAYLIST_QUERY,
        {
            variables: { "id": String( id ) },
            fetchPolicy: "no-cache"
        } );

    if ( loading ) {
        return (
            <StyledDiv>
                <Loader
                    message="Loading"
                    primaryColor={ WerfenColor }
                    secondaryColor={ Shadow }
                    fontColor={ Black }
                    extraStyle="margin-top: 10%"
                />
            </StyledDiv>
        )
    }

    if ( error ) {
        return (
            <StyledDiv>
                <div>
                    <h1>No data recovered</h1>
                </div>
            </StyledDiv>
        )
    }

    if ( data && data.nodeById ) {
        playlist = classifyResult ( data.nodeById );
    } else {
        playlist = {
            title: "Error",
            fieldPlaylistDescription: "The Playlist you are trying to access seems to be out of your scope. Press the back arrow and try another one.",
            elementCounter: 0,
            isFav: null,
        }
    }

    const title = decodeURIComponent ( playlist.title );
    const description = playlist.fieldPlaylistDescription ? decodeURIComponent ( playlist.fieldPlaylistDescription ) : "";
    const { elementCounter, availableOffline, isFav, tabContextActions, tabs } = playlist;
    const combineTabs = ( tabs ) => {
        let unifiedList = [];
        tabs && tabs.map ( ( tab ) => {
                for ( let i = 0; i < tab.files.length; i++ ) {
                    const dateChanged = tab.files[i].metadata.entityChanged;
                    let dateUpdated = formatDateAsDay(dateChanged);
                    if (process.env.REACT_APP_SEE_DATES === "1") {
                      dateUpdated = (dateChanged === null ? "Unknown" : dateUpdated);
                    }

                    tab.files[i].metadata.created = formatDateAsDay(tab.files[i].metadata.entityCreated);
                    tab.files[i].metadata.updated = dateUpdated;
                    tab.files[i].metadata.section = tab.title;
                }
                unifiedList = unifiedList.concat ( tab.files ).sort ( ( a, b ) => {
                    return new Date ( b.metadata.entityCreated ) - new Date ( a.metadata.entityCreated );
                } )
            }
        )
        return unifiedList;
    }

    if ( tabs && isUnifiedTable ) {
        combinedTabs = combineTabs ( tabs );
    }

    const debounce = ( func, wait ) => {
        let timeout;
        return ( ...args ) => {
            clearTimeout ( timeout );
            timeout = setTimeout ( () => func.apply ( this, args ), wait );
        };
    };

    const handleSearch = debounce ( ( value ) => {
        if ( !tabs ) return;

        if ( !value.trim () ) {
            setFilteredTabs ( null );
            setFilteredCombinedTabs ( [] )
            return;
        }

        const searchValue = value.toLowerCase ();

        if ( isUnifiedTable === false ) {
            const filtered = tabs.map ( tab => ( {
                ...tab,
                files: tab.files.filter ( file =>
                    file.metadata.filename.toLowerCase ().includes ( searchValue ) ||
                    ( file.metadata.description && file.metadata.description.toLowerCase ().includes ( searchValue ) )
                )
            } ) ).filter ( tab => tab.files.length > 0 )
            setFilteredTabs ( filtered );
        } else {
            const filteredCombined = combinedTabs.filter ( file =>
                file.metadata.filename.toLowerCase ().includes ( searchValue ) ||
                ( file.metadata.description && file.metadata.description.toLowerCase ().includes ( searchValue ) ) ||
                file.metadata.section.toLowerCase ().includes ( searchValue )
            )
            setFilteredCombinedTabs ( filteredCombined );
        }
    }, 300 );

    return (
        <StyledDiv>
            <RelativeDiv className={ "RelativeDiv" }>
                <Header
                    isPlaylist
                    upperMiniTitle={ "Playlist" }
                    title={ title }
                    description={ description }
                    elementCounter={ elementCounter }
                    availableOffline={ availableOffline }
                    addPlaylistToDownloadQueue={ props.addPlaylistToDownloadQueue }
                    isFav={ isFav }
                    session={ session }
                    playlist={ playlist }
                    itemId={ id }
                    goBack={ false }
                />
                { tabs && tabs.length > 0 &&
                    <TabWrapper>
                        <TabSection className={ "TabSection" }>
                            <ToggleWrapper className={ 'toggle-wrapper' }
                                           isUnifiedTable={ isUnifiedTable }
                            >
                                <Label
                                    className={ isUnifiedTable === false ? 'custom-control-label' : 'custom-control-label inactive' }
                                >
                                    See as Sections
                                </Label>
                                <StyledToggle
                                    type="switch"
                                    id="custom-switch"
                                    className="custom-control"
                                >
                                    <Form.Check.Input
                                        type="checkbox"
                                        className="custom-control-input"
                                        checked={ isUnifiedTable === true }
                                        onChange={ handleToggle }
                                    />
                                    <Form.Check.Label
                                        className="custom-control-label"
                                    />
                                </StyledToggle>
                                <Label
                                    className={ isUnifiedTable === true ? 'custom-control-label' : 'custom-control-label inactive' }
                                > See as Table </Label>
                            </ToggleWrapper>
                        </TabSection>
                        { isUnifiedTable === false && <TabSection className={ "TabSection" }>
                            <DropdownMenu id="playlist" contextActions={ tabContextActions }>
                                <IconWrapper
                                    color={ White }
                                    fillColor={ White }
                                    width="30px"
                                    iconStyle="position: absolute; right: 10px; &:hover{ cursor: pointer }"
                                    Icon={ SettingsIcon }
                                />
                            </DropdownMenu>
                        </TabSection> }
                    </TabWrapper>
                }
            </RelativeDiv>
            { isUnifiedTable === false ? ( <PlaylistByTabs
                tabs={ tabs }
                filteredTabs={ filteredTabs }
                selectedTab={ selectedTab }
                handleSearch={ handleSearch }
                searchTerm={ searchTerm }
                setSearchTerm={ setSearchTerm }
                settings={ settings }
                isUnifiedTable={ isUnifiedTable }
                session={ session }
            /> ) : (
                <PlaylistAsTable
                    selectedTab={ selectedTab }
                    combinedTabs={ combinedTabs }
                    filteredCombinedTabs={ filteredCombinedTabs }
                    handleSearch={ handleSearch }
                    searchTerm={ searchTerm }
                    setSearchTerm={ setSearchTerm }
                    isUnifiedTable={ isUnifiedTable }
                    settings={ settings }
                /> ) }
            <Modal show={ props.visibleModalBokecc }
                   onHide={ props.hideModalBokecc }
                   size="lg"
                   backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>{ props.modalTitle }</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <StyledModalBody dangerouslySetInnerHTML={ createMarkup ( props.modalBody ) }/>
                </Modal.Body>
            </Modal>
            { props.dialogVisible &&
                <Dialog/>
            }
        </StyledDiv>
    )
}

const mapStateToProps = ( state ) => {
    return {
        download: state.download.download,
        playlist: state.playlist,
        session: state.session,
        settings: state.settings,
        visibleModalBokecc: state.ui.visibleModalBokecc,
        modalTitle: state.ui.modalTitle,
        modalBody: state.ui.modalBody,
        dialogVisible: state.ui.dialogVisible,
    }
}

const mapDispatchToProps = ( dispatch ) => {
    return bindActionCreators ( {
        addPlaylistToDownloadQueue,
        addDownload,
        showBackArrow,
        showModalBokecc,
        hideModalBokecc,
        setTitleBar,
        hideSearchBar,
    }, dispatch )
}

export default connect ( mapStateToProps, mapDispatchToProps ) ( Playlist );
